module.exports = __webpack_public_path__ + "img/search.c7d96fbd.svg";